<template>
    <div v-intersection.once="onIntersection" :class="visibleClassFive" class="about-container">
    <div class="container section">
       <p>The As I am campaign celebrates diversity, aims to increase the visibility of our Black and Asian staff and students at Man Met and provide insight into cultural identity and belonging.</p>

        <p>This exhibition celebrates our staff and students and gives a small insight into who they are, for when we gain an understanding of the individuals we teach, study and work with, we learn to appreciate the different lenses from which we see life and it enables us to create spaces for meaningful and authentic exchanges. This webpage has been produced to house the full stories of those who have contributed to the campaign. This online space is intended to live beyond the physical exhibition and will be continuously populated with diverse faces and stories offering a space for inspiration, creativity, and visibility.</p>

        <p>The physical exhibition of this campaign will take place in Manchester Poetry Library before becoming a touring exhibit, operating in multiple spaces across Manchester Met's campus. These exhibitions will be a space where attendees can immerse themselves in the portraits, profiles, and stories shared by the campaign’s contributors. We invite you to come along, learn, network, and share tales of your own cultural identity.</p>

        <p><b>More profiles will be added soon, check back later!</b></p>
 
    </div>
    <Carousel @findProfile = "menuOpenHandler" :images="images" />
    </div>
</template>

<script>

import Carousel from '../components/Carousel.vue'
import { scroll } from 'quasar'
import { ref } from '@vue/reactivity'
import { computed } from '@vue/runtime-core'

export default {
    props: ["images"],
    components: { Carousel },
    setup() {
        const { getScrollTarget } = scroll
        const visible = ref(true)

        const onIntersection = (entry) => {
            const mediaQuery = window.matchMedia('(min-width: 600px)')
            mediaQuery.matches ? visible.value = entry.isIntersecting : visible.value = true 
        }

        const visibleClassFive = computed(() => { 
            if(visible.value) {
                return 'show-five'
            } else {
                return 'hide-five'
            }
        })

        return {
            getScrollTarget,
            onIntersection,
            visible,
            visibleClassFive
        }
    }

}
</script>

<style lang="scss">



</style>


